import { Theme, createStyles, makeStyles } from '@material-ui/core'

export default makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: '2rem',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      [theme.breakpoints.up('xl')]: {
        padding: '5rem 18rem',
      }
    },
    title: {
      fontFamily: 'OutfitHeavy',
      textTransform: 'uppercase',
      color: '#A5965A',
      fontSize: '3.5rem',
      textAlign: 'center',
      [theme.breakpoints.down('sm')]: {
        fontSize: "2.5rem"
      }
    },
    subtitle: {
      textAlign: 'center',
      fontSize: '24px',
      width: '70%'
      // padding: '1rem 4rem',
    },
    card: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '1.5rem',
    },
    card__container: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      alignItems: 'center',
      gap: '5rem',
      marginTop: '4rem',
      [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: 'repeat(1, 1fr)',
        gap: '3rem'
      }
    },
    card__title: {
      textTransform: 'uppercase',
      fontFamily: 'OutfitHeavy',
      fontSize: '24px',
      textAlign: 'center',
    },
    card__subtitle: {
      textAlign: 'center',
      padding: '0 2.5rem',
      [theme.breakpoints.down('sm')]: {
        padding: '0'
      }
    },
    icon: {
      width: '130px'
    }
  })
)
